










































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_areas from '@/mixins/axios/indicador_areas'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'
//@ts-ignore
import IndicadorArea from '@/components/headersSelect/indicadorArea'

//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    IndicadorArea,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
            
            
            
            {
                tag:'area_indicador',
                data:'area_indicador',
                active:true
            },
             {
                tag:'select_dim',
                data:'select',
                active:false
            },
           
             {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            
           
        ],




        id:null as any,

      area_indicador:'' as any,
     
     
         
         
              indicador_areasdata:[] as any,
      
    }
  },
     mixins: [indicador_areas],
     validations: {
    
           area_indicador: {
      required,
    },
 
     

   
  },
  methods:{
       clearstate(){
this.$store.commit('SETINDICADORAREA',null);
 this.$router.push('/mun/general/indicadores/catalogos/areas')
        },
         select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETINDICADORAREA',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/indicadores/catalogos/areas/dimensiones')
//this.getDataDepartamentos();

      
     },

      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_AREAS(row).then(response => {

                    if (response != null) {

 this.indicador_areasdata=this.indicador_areasdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.area_indicador=null;

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_area').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.area_indicador=row.area_indicador;

            
          
 $('#ac_modal_indicador_area').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_AREASS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_areasdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador areas, refresque la pagina");

                    }
                        $("#ac_modal_indicador_area").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_AREASS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("alerta_show", "Ocurrio un error al intentar Indicador Area, refresque la pagina");
  this.indicador_areasdata=this.indicador_areasdata.filter(item => item.id !== dat.id);
 this.indicador_areasdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Indicador Area, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           area_indicador:this.area_indicador,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_AREAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_areasdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

